export default "__VITE_ASSET__ef44429a__"